import { clsx } from 'clsx';

import ChevronRight from '../../../components/svg/ChevronRight.svg';
import CTARocket from '../../../components/svg/CTABanner.svg';
import TelephoneIcon from '../../../components/svg/SolidTelephone.svg';
import { iwocapayTelDisplay, iwocapayTelLink } from '../../../constants.json';

const SEMI_CIRCLE_CLASS =
  "relative h-[0.75rem] w-[2.5rem] overflow-hidden after:absolute after:left-[-1.125rem] after:top-[-1.5rem] after:h-[1.5rem] after:w-[1.5rem] after:rounded-full after:border-[1.5rem] after:border-solid after:border-white after:content-['']";

export const StatusTemplate = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="flex flex-col items-center p-[1.5rem_1rem] text-denim-25 m800:p-[4.325rem]">
      <div className="box-border w-[21.5rem] bg-white p-[1rem] text-center shadow-[0_15px_25px_rgba(0,0,0,0.1)] m800:w-[29.5rem] m800:p-[2rem_2.5rem] [&_hr]:border [&_hr]:border-solid [&_hr]:border-london-95">
        <div className="pt-[1.5rem] m800:p-[1rem_0]">{children}</div>
        <BecomeASellerCTA />
        <div className="mb-r mt-2xl flex flex-row items-center justify-center text-primary-10 m800:mb-0">
          <div className="mr-xl">Need some help?</div>
          <div>
            <div className="text-xs">
              <img
                src={TelephoneIcon}
                className="h-auto w-[12px] pr-xs"
                alt=""
              />
              <span className="text-success-drk">Open</span> Mon 9-6pm
            </div>
            <div className="font-bold [&_a:hover]:underline [&_a]:text-[unset] [&_a]:no-underline">
              <a href={iwocapayTelLink}>{iwocapayTelDisplay}</a>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-[1rem] flex w-[21.5rem] m800:w-[29.5rem]">
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={SEMI_CIRCLE_CLASS} />
        <div className={clsx(SEMI_CIRCLE_CLASS, 'hidden m800:block')} />
        <div className={clsx(SEMI_CIRCLE_CLASS, 'hidden m800:block')} />
        <div className={clsx(SEMI_CIRCLE_CLASS, 'hidden m800:block')} />
      </div>
    </div>
  );
};

const BecomeASellerCTA = () => {
  return (
    <div className="grid h-[130px] w-full grid-cols-[200px_auto] overflow-hidden rounded-m border border-solid border-secondary-90 bg-secondary-95 m800:h-[170px] m800:grid-cols-[230px_auto]">
      <div className="flex flex-col justify-center p-l text-left text-s font-bold text-primary-10 m800:text-m">
        <div data-testid="cta-ad-text">
          Access £1,000 &ndash; £1,000,000
          <br />
          today with an iwoca
          <br />
          business loan
        </div>
        <div className="mt-s flex items-center">
          <a
            href="https://www.iwoca.co.uk/?utm_source=internal-website&utm_medium=iwocapay&utm_campaign=buyers#compare"
            className="font-bold text-primary-40 no-underline hover:underline"
          >
            Apply in minutes here
          </a>
          <img src={ChevronRight} alt={'Apply here'} />
        </div>
      </div>
      <div className="overflow-hidden">
        <img
          src={CTARocket}
          className="mt-0 m800:mt-[-18px]"
          alt={''}
          width="120%"
        />
      </div>
    </div>
  );
};
